import { GlobalContext } from 'context/GlobalProvider';
import _get from 'lodash/get';
import SystemUnavailable from 'pages/Error/SystemUnavailable';
import React from 'react';

class ErrorBoundary extends React.Component {
    state = { hasError: false };

    static contextType = GlobalContext;

    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    render() {
        const hasGlobalError = _get(this.context, 'state.hasError', false);
        return hasGlobalError || this.state.hasError ? <SystemUnavailable /> : this.props.children;
    }
}

export default ErrorBoundary;
